import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadablePrescreenOffer = loadable(() => import('./PrescreenOffer'), {
  fallback: <LoadingScreen />,
});

export default LoadablePrescreenOffer;
